import CustomModal from "../CustomModal";

const DeletePlanModal = ({ isOpen, onClose, onConfirmDelete }) => {
  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Delete Modal"
      className="delete-modal"
    >
      <div className="delete-modal-inner">
        <img
          src={`${process.env.PUBLIC_URL}/images/delete-danger.png`}
          alt="Warning icon"
        />
        <p>Do you want to delete this Plan</p>
        <div className="delete-modal-button">
          <button className="delete-btn1" onClick={onConfirmDelete}>
            Delete
          </button>
          <button className="delete-btn2" onClick={onClose}>
            Back
          </button>
        </div>
      </div>
    </CustomModal>
  );
};

export default DeletePlanModal;
